import Cesium from 'cesium';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Root from './components/Root';
import configureLogging from './configureLogging';
import createStore from './createStore';
import * as InitActions from './actions/init';

import './styles/index.scss';

configureLogging();

// configure the location of the cesium dll
Cesium.buildModuleUrl.setBaseUrl(`${process.env.PUBLIC_URL}/cesium/`);

// prepare the store
const store = createStore();

// dispatch the load action
store.dispatch(InitActions.load());
document.getElementById('splash-screen').style.display = 'none';

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js